import React from 'react';
import { ArrowRight, ArrowDown } from 'lucide-react';
import { Button } from '../components/ui/button';

const colors = {
  gold: '#c9a227',
  tealArmonizador: '#00675b',
};

const HeroTest = () => {
  const newPhotoUrl = "https://customer-assets.emergentagent.com/job_light-school-1/artifacts/zbiejhmz_Gemini_Generated_Image_1x9m5f1x9m5f1x9m.png";

  return (
    <div className="pt-20">
      {/* Header */}
      <div className="bg-gray-900 text-white py-6 px-6 text-center">
        <h1 className="text-2xl font-bold">Propuestas Hero - Ajuste de difuminado</h1>
      </div>

      {/* ===== OPCIÓN 1: Degradado más suave (menos difuminado a la derecha) ===== */}
      <div className="py-8 bg-gray-100">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
            OPCIÓN 1: Degradado más suave - Te ves más claro
          </h2>
          
          <div className="relative min-h-[500px] rounded-2xl overflow-hidden shadow-xl">
            {/* Background image */}
            <div className="absolute inset-0">
              <img 
                src={newPhotoUrl}
                alt="Herminio"
                className="w-full h-full object-cover object-top"
              />
              {/* Gradient overlay - más suave */}
              <div className="absolute inset-0 bg-gradient-to-r from-white via-white/60 to-transparent" />
            </div>
            
            {/* Content */}
            <div className="relative h-full min-h-[500px] flex items-center">
              <div className="max-w-xl px-8 lg:px-12 space-y-6">
                <div className="w-12 h-[2px]" style={{ backgroundColor: colors.gold }} />
                <h1 className="text-4xl lg:text-5xl font-serif text-gray-800 leading-tight">
                  Un espacio para volver a ti.
                  <span className="block mt-2" style={{ color: colors.tealArmonizador }}>
                    Sin prisa. Sin ruido.
                  </span>
                </h1>
                <p className="text-lg text-gray-600 leading-relaxed">
                  De la desconexión y el esfuerzo constante, a habitar tu cuerpo, 
                  tu consciencia y tu vida con claridad y estabilidad.
                </p>
                <div className="flex gap-4 pt-4">
                  <Button style={{ backgroundColor: colors.gold }} className="text-white px-6 py-5">
                    Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== OPCIÓN 2: Sin degradado en la derecha ===== */}
      <div className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
            OPCIÓN 2: Degradado solo hasta el centro - Imagen más nítida
          </h2>
          
          <div className="relative min-h-[500px] rounded-2xl overflow-hidden shadow-xl">
            {/* Background image */}
            <div className="absolute inset-0">
              <img 
                src={newPhotoUrl}
                alt="Herminio"
                className="w-full h-full object-cover object-top"
              />
              {/* Gradient overlay - solo lado izquierdo */}
              <div className="absolute inset-0 bg-gradient-to-r from-white from-30% via-white/40 via-50% to-transparent to-70%" />
            </div>
            
            {/* Content */}
            <div className="relative h-full min-h-[500px] flex items-center">
              <div className="max-w-xl px-8 lg:px-12 space-y-6">
                <div className="w-12 h-[2px]" style={{ backgroundColor: colors.gold }} />
                <h1 className="text-4xl lg:text-5xl font-serif text-gray-800 leading-tight">
                  Un espacio para volver a ti.
                  <span className="block mt-2" style={{ color: colors.tealArmonizador }}>
                    Sin prisa. Sin ruido.
                  </span>
                </h1>
                <p className="text-lg text-gray-600 leading-relaxed">
                  De la desconexión y el esfuerzo constante, a habitar tu cuerpo, 
                  tu consciencia y tu vida con claridad y estabilidad.
                </p>
                <div className="flex gap-4 pt-4">
                  <Button style={{ backgroundColor: colors.gold }} className="text-white px-6 py-5">
                    Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== VERSIÓN MÓVIL ===== */}
      <div className="py-8 bg-gray-100">
        <div className="max-w-md mx-auto px-6">
          <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
            VERSIÓN MÓVIL: Imagen arriba, texto abajo
          </h2>
          
          <div className="rounded-2xl overflow-hidden shadow-xl bg-white">
            {/* Image on top */}
            <div className="h-72 relative">
              <img 
                src={newPhotoUrl}
                alt="Herminio"
                className="w-full h-full object-cover object-top"
              />
              {/* Subtle gradient at bottom for smooth transition */}
              <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent" />
            </div>
            
            {/* Content below */}
            <div className="px-6 py-8 space-y-5">
              <div className="w-10 h-[2px]" style={{ backgroundColor: colors.gold }} />
              <h1 className="text-2xl font-serif text-gray-800 leading-tight">
                Un espacio para volver a ti.
                <span className="block mt-1" style={{ color: colors.tealArmonizador }}>
                  Sin prisa. Sin ruido.
                </span>
              </h1>
              <p className="text-base text-gray-600 leading-relaxed">
                De la desconexión y el esfuerzo constante, a habitar tu cuerpo, 
                tu consciencia y tu vida.
              </p>
              <div className="flex flex-col gap-3 pt-2">
                <Button style={{ backgroundColor: colors.gold }} className="text-white w-full py-5">
                  Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                </Button>
                <Button variant="ghost" className="text-gray-600 w-full py-5">
                  Explorar formaciones <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Instructions */}
      <div className="py-8 bg-gray-900 text-white text-center">
        <h2 className="text-xl font-bold mb-4">¿Qué prefieres?</h2>
        <ul className="space-y-2 text-gray-300">
          <li>• <strong>Desktop:</strong> ¿Opción 1 o 2 para el difuminado?</li>
          <li>• <strong>Móvil:</strong> ¿Te gusta imagen arriba + texto abajo?</li>
        </ul>
      </div>
    </div>
  );
};

export default HeroTest;
